import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const STORAGE_PARTNER_REFERRAL = "partner_referral_code";
/** Marketing UTM landing tag (?s=key from hyperclapper.com/?s=...) */
export const STORAGE_UTM_TAG_KEY = "signup_utm_tag_key";

/**
 * Capture URL params for signup attribution — renders nothing.
 * - ?ref= → Partnero referral (storage: partner_referral_code)
 * - ?s=  → landing UTM tag key (storage: signup_utm_tag_key)
 */
const ReferralCapture = () => {
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    const referralCode = queryParams.get("ref");
    if (referralCode) {
      localStorage.setItem(STORAGE_PARTNER_REFERRAL, referralCode.trim());
      console.log("Partner referral captured:", referralCode.trim());
    }

    const utmTag = queryParams.get("s");
    if (utmTag && utmTag.trim()) {
      localStorage.setItem(STORAGE_UTM_TAG_KEY, utmTag.trim());
      console.log("Signup UTM tag (s) captured:", utmTag.trim());
    }
  }, [location]);

  return null;
};

export default ReferralCapture;
